import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { Icon } from "../generic/icon/Icon";
import { List } from "../generic/list/List";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
export var ListResourceRewards = function (_a) {
    var items = _a.items;
    var renderItem = function (_a) {
        var icon = _a.icon, amount = _a.amount, loca = _a.loca;
        var iconStyle = "pos-rel allow-overflow " + IdStyles.IconSmall;
        return (React.createElement("div", { className: IdStyles.RewardListEntryMid + " flex flex--aligned margin--medium padding--small" },
            React.createElement(Icon, { icon: icon, styleId: iconStyle },
                React.createElement(Badge, { position: IdBadgePosition.Bottom },
                    React.createElement(NumberFormat, { amount: amount, format: TypeNumberFormat.Percent, className: IdStyles.TextSmallBoldSecondaryOutline }))),
            React.createElement(TextLoca, { id: loca, className: IdStyles.TextNormal + " pl__medium" })));
    };
    return React.createElement(List, { className: "flex flex--wrap pad", items: items, renderItem: renderItem });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/ListResourceRewards.tsx
// module id = 2931
// module chunks = 3